import {ChangeDetectionStrategy, Component, computed, input, signal} from '@angular/core';
import {AppNumberPipe} from '@frontend/shared';
import {TranslocoPipe} from '@jsverse/transloco';
import {CoverageAnalysisView, CoverageMatrixRow} from '../rfi-coverage-analysis-dialog.types';
import {CoverageTabHeaderComponent} from '../coverage-tab-header/coverage-tab-header.component';
import {CoverageOptionToggleComponent} from '../coverage-option-toggle/coverage-option-toggle.component';

@Component({
  selector: 'app-coverage-matrix-tab',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AppNumberPipe,
    TranslocoPipe,
    CoverageTabHeaderComponent,
    CoverageOptionToggleComponent,
  ],
  templateUrl: './coverage-matrix-tab.component.html',
})
export class CoverageMatrixTabComponent {
  readonly view = input.required<CoverageAnalysisView>();

  protected readonly onlyGapCountries = signal(false);

  protected readonly visibleCountries = computed(() => {
    const countries = this.view().countries;
    return this.onlyGapCountries() ? countries.filter((country) => country.hasGap) : countries;
  });
  protected readonly visibleRows = computed((): CoverageMatrixRow[] => {
    const visibleIsoCodes = new Set(this.visibleCountries().map((country) => country.isoCode));
    return this.view().matrixRows.map((row) => ({
      ...row,
      cells: row.cells.filter((cell) => visibleIsoCodes.has(cell.isoCode)),
    }));
  });
  protected readonly hintParams = computed(() => ({count: this.view().countries.length}));
}
